// Pages
import VirtualSportListPage from "./pages/VirtualSportListPage";
import VirtualSportApprovalPage from "./pages/VirtualSportApprovalPage";

export const virtualSportRoutes = (prefix = "virtual-sport") => [
  {
    name: "VirtualSportListPage",
    path: `${prefix}`,
    component: VirtualSportListPage,
  },
  {
    name: "VirtualSportApprovalPage",
    path: `${prefix}/:id`,
    component: VirtualSportApprovalPage,
  },
];
